<div class="layout-padding" fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="row">
    <h3 class="mat-headline-6">Lab Fees</h3>
    <mat-icon [matTooltip]="description">info</mat-icon>
  </div>
  <pt-download-report
    [data]="csvData$ | async"
    [dateRange]="dateRange$ | async"
    [csvTranslator]="csvTranslator"
  />
</div>

<table
  mat-table
  fxFlex
  matSort
  matSortActive="labJobDate"
  matSortDirection="asc"
  [dataSource]="dataSource"
>
  <ng-container matColumnDef="labJobDate">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>
      {{ labJobDateLabel }}
    </th>
    <td *matCellDef="let record" mat-cell>
      {{
        record.labJob[labJobTimestampField] | moment | amDateFormat: dateFormat
      }}
    </td>
    <td *matFooterCellDef mat-footer-cell></td>
  </ng-container>

  <ng-container matColumnDef="patient">
    <th *matHeaderCellDef mat-header-cell>Patient</th>
    <td *matCellDef="let record" mat-cell>
      <a
        target="_blank"
        [routerLink]="record.labJob.patient | patientUrl$ | async"
      >
        {{ record.labJob.patient.name }}
      </a>
    </td>
    <td *matFooterCellDef mat-footer-cell></td>
  </ng-container>

  <ng-container matColumnDef="lab">
    <th *matHeaderCellDef mat-header-cell>Lab</th>
    <td *matCellDef="let record" mat-cell>
      <a
        target="_blank"
        [prPracticeRouterLink]="['labs', record.labJob.lab.ref.id]"
      >
        {{ record.labJob.lab.name }}
      </a>
    </td>
    <td *matFooterCellDef mat-footer-cell></td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th *matHeaderCellDef mat-header-cell>Lab Job</th>
    <td *matCellDef="let record" mat-cell>
      <a
        target="_blank"
        [prPracticeRouterLink]="['lab-jobs']"
        [queryParams]="{ labJob: record.labJob.ref.id }"
      >
        {{ record.labJob.type.name }}
      </a>
    </td>
    <td *matFooterCellDef mat-footer-cell></td>
  </ng-container>

  <ng-container matColumnDef="cost">
    <th *matHeaderCellDef mat-header-cell>
      <pr-value-with-icon>Cost</pr-value-with-icon>
    </th>
    <td *matCellDef="let record" mat-cell>
      <pr-value-with-icon>{{
        record.summary.labFeesAmount | currency
      }}</pr-value-with-icon>
    </td>
    <td *matFooterCellDef mat-footer-cell>
      <pr-value-with-icon>
        <strong>
          {{ total$ | async | currency }}
        </strong>
      </pr-value-with-icon>
    </td>
  </ng-container>

  <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
  <tr *matFooterRowDef="displayedColumns" mat-footer-row></tr>
</table>
